/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {useNavigate, useParams} from "react-router-dom";
/* Components */
import Header from "../../../../components/common/Header";
import {getCmsTextInfos} from "../../../../api/admin/cmsReq";
import useAuth from "../../../../hooks/useAuth";
import TiptapView from "../../../../components/common/input-layout/tiptap/TiptapView";
import FormCmsText from "../../../../forms/admin/cms/FormCmsText";
import useData from "../../../../hooks/useData";
import Icon from "../../../../components/common/Icon";


export default function ViewCmsText({category}) {
    const {id} = useParams();
    const { auth } = useAuth();
    const token = auth?.token;
    const { cmsTextInfos, setCmsTextInfos } = useData();
    const [ showModal, setShowModal ] = useState(false);
    const [ forceHideModal, setForceHideModal ] = useState(false);
    const navigate = useNavigate();

    const apiCmsTextInfos = async () => {
        const response = await getCmsTextInfos(token, id);
        setCmsTextInfos(response);
    }

    const handleBack = () => {
        if (slug != "") {
            navigate(`/admin/cms/${slug}/`);
        }
    }

    const handleModal = () => {
        setShowModal(true)
    }

    useEffect(() => {
        apiCmsTextInfos();
    }, [ id ]);

    const handleRemoveCmsModal = (e) => {
        if (e.target.classList.contains("cms-text")) {
            if (id == 0) {
                setForceHideModal(true)
                setShowModal(false)
            }
            setShowModal(false)
        }
    };

    let location;
    let slug;
    switch (category) {
        case 3:
            location = "Cms : Mentions légales";
            slug = "mentions/legales";
            break;
        case 4:
            location = "Cms : Cookies";
            slug = "cookies";
            break;
        case 5:
            location = "Cms : Données personnelles";
            slug = "rgpd";
            break;
        default:
            location = "Cms : Texte formulaires";
            slug = "formulaires";
    }

    return (
        <main>
            <Header parent="CMS"
                    location={ (id != 0)
                        ? `Modification ${location}`
                        : `Ajout ${location}`}
                    locationComp ={`${cmsTextInfos?.title ? cmsTextInfos?.title : "" }`}
                    slug={`/admin/cms/${slug}/`}
            />
            { ((id == 0 && forceHideModal == false) || showModal) &&
                <div className="modal cms-text">
                    <FormCmsText apiCmsTextInfos={apiCmsTextInfos} setShowModal={setShowModal} category={category}/>
                </div>
            }
            <fieldset>
                <Icon span={`Modification - ${location}`} source="fa fa-file-lines" />
                <div className="form-input">
                <label>L'article a un titre ?</label>
                    <span id="hasTitle">{cmsTextInfos?.hasTitle ? "Oui" : "Non"}</span>
                </div>
                <div className="form-input">
                    <label>Titre de l'article</label>
                    <span id="title">{cmsTextInfos?.title}</span>
                </div>
                <div className="form-input html-textarea">
                    <label>Contenu</label>
                    <TiptapView content={cmsTextInfos?.content}/>
                </div>
                <div className="form-input">
                    <label htmlFor="updatedAt">Dernière mise à jour de l'article</label>
                    <span id="updatedAt">{cmsTextInfos?.updatedAt}</span>
                </div>
                <div className="buttons-container">
                    <button type="button" onClick={() => handleBack(location)}><i className="fa fa-arrow-left"/><span>Retour</span></button>
                    <button className="red-button" onClick={handleModal}><i className="fa fa-pen-to-square"/><span>Modifier les informations</span></button>
                </div>
            </fieldset>
        </main>
    )
}